import { render, staticRenderFns } from "./SidebarMenuTech.vue?vue&type=template&id=ee557fb4"
import script from "./SidebarMenuTech.vue?vue&type=script&lang=js"
export * from "./SidebarMenuTech.vue?vue&type=script&lang=js"
import style0 from "./SidebarMenuTech.vue?vue&type=style&index=0&id=ee557fb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports